import { fetchGet } from '@/axios/index.js'

export const getArticlePage = params => { return fetchGet('/api/article/page',params) }

export const articleDetail = params => { return fetchGet('/api/article/get/' + params) }

export const imageHonor = params => { return fetchGet('/api/article/img/' + params) }

export const articlezlsDetail = params => { return fetchGet('/api/article/get/zls/' + params) }


// WEBPACK FOOTER //
// ./src/axios/front.js